import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import Spinner from 'web/components/Spinner'
import AlertModal from 'web/components/AlertModal';
import { Modal, ModalBody } from 'reactstrap';
import { RequestTenderModalWrapper, RequestTenderModalContentWrapper, SelectWrapper } from "../myOrderStyled";
import CloseIcon from "web/assets/images/CloseIcon.png";
import DatePickerIcon from 'web/assets/svg/DatePickerIcon';
import TimerIcon from 'web/assets/svg/TimerIcon'
import DropDown from "web/components/DropDown";
import { fetchDeliveryRequestTenderDataApi, requestDeliveryTendorApiCall } from "redux/actions/requestOrderPtplus";
import PaymentSection from "./PaymentSection";

function RequestTender(props) {
  const token = localStorage.getItem("token")
  const dispatch = useDispatch();
  let history = useHistory();
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible)
  const [comment, setComment] = useState('')
  const [selectedVendor, setSelectedVendor] = useState()
  const [vendorsList, setVendorsList] = useState([])
  const [alertModal, setAlertModal] = useState(false)
  const [alertModalContent, setAlertModalContent] = useState('')
  const [alertModalType, setAlertModalType] = useState()
  const [pageData, setPageData] = useState()
  const [paymentPageStateValues, setPaymentPageStateValues] = useState({
    selectedPaymentOption: '',
    isAchSelected: false,
    paymentMethod: '',
    achBackUpCard: null,
    isAchBackupAcknowldged: false
  })

  useEffect(() => {
    let selectedItemRefNo = localStorage.getItem('requestTenderSelectedItemId')
    localStorage.removeItem('requestTenderSelectedItemId')
    fetchPageData(selectedItemRefNo)
  }, [])

  const fetchPageData = async (selectedItemRefNo) => {
    let data = {
      authId: localStorage.getItem('authId'),
      orderRefNumber: selectedItemRefNo
    }
    let response = await dispatch(fetchDeliveryRequestTenderDataApi(data, token));
    if (response.data?.success) {
      setPageData(response.data?.data)
      let vendorsList = response.data?.data?.vendorDetails?.map(data => {
        return ({
          label: data.vendorLocationName,
          value: data.vendorLocationId,
          equipment: data.equipment,
          palletDetails: data?.palletDetails,
          vendorFee: data?.vendorFee,
          customerFee: data?.customerFee,
          vendorComment: data?.vendorComment
        })
      })
      if (vendorsList && vendorsList?.length > 0) setVendorsList(vendorsList)
      else {
        setAlertModalType('closeModal')
        setAlertModalContent('There is no active published rate or management fee associated for this customer/location. Please navigate to the PT Admin console to update a rate.')
        setAlertModal(!alertModal)
      }
    } else {
      setAlertModalType('closeModal')
      if (response?.data?.error?.message === "Invalid Token" || response?.data?.error?.message === 'Request failed with status code 401') {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setAlertModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again in some time.')
        setAlertModal(!alertModal)
      }
    }
  }

  const requestTenderFunction = async () => {
    if (!selectedVendor) {
      setAlertModalContent('Please select a vendor.')
      setAlertModal(true)
    } else if (paymentPageStateValues.isAchSelected && !paymentPageStateValues?.achBackUpCard) {
      setAlertModalContent('Please select a backup card for ACH.')
      setAlertModal(true)
    } else if (paymentPageStateValues.isAchSelected && !paymentPageStateValues?.isAchBackupAcknowldged) {
      setAlertModalContent('Please acknowledge the terms.')
      setAlertModal(true)
    } else {
      let data = {
        authId: localStorage.getItem('authId'),
        orderRefNumber: pageData?.orderRefNumber,
        vendorLocationId: selectedVendor?.value,
        equipmentRequirements: pageData?.equipmentRequirements,
        equipment: selectedVendor?.equipment || 'FTL',
        palletDetails: selectedVendor?.palletDetails,
        vendorFee: selectedVendor?.vendorFee,
        customerFee: selectedVendor?.customerFee,
        comment: comment,
        buyerPaymentDetails: {
          paymentMethod: paymentPageStateValues.paymentMethod,
          paymentMethodId: paymentPageStateValues?.selectedPaymentOption,
          achPaymentMethodIds: paymentPageStateValues?.isAchSelected ? [paymentPageStateValues?.selectedPaymentOption, paymentPageStateValues?.achBackUpCard?.value] : null
        }
      }
      let response
      response = await dispatch(requestDeliveryTendorApiCall(data, token))
      if (response?.data?.success) {
        setAlertModalType('requestTendorSuccess')
        setAlertModalContent(response?.data?.data?.msg)
        setAlertModal(!alertModal)
      } else {
        if (response?.data?.error?.message === 'Invalid Token') {
          history.push('./sign-in')
        } else {
          setAlertModalContent(response?.data?.data?.message || response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.')
          setAlertModal(!alertModal)
        }
      }
    }
  }

  const palletDetailsString = (data) => {
    let material = data?.material;
    let condition = data?.condition?.length !== 1 ? data?.condition?.join(", ") : data?.condition;
    let moisture = data?.moisture ? `, ${data?.moisture}` : "";
    let size = data?.size ? (data?.size === "Custom" ? `${data?.size}, ${data?.length}x${data?.width}x${data?.height}` : data?.size) : "";
    let grade = data?.grade ? `, ${data?.grade}` : "";
    let isHeatTreated = data?.heatTreared ? ", HT" : "";
    let palletType = data?.material === "WOOD" ? `, ${data?.palletType}` : "";
    let hardOrSoftWood = data?.newConditionType === "HARDWOOD" ? "(HW)" : (data?.newConditionType === "SOFTWOOD" ? "(SW)" : "");
    let LWH = data?.material !== "WOOD" ? `${data?.length}x${data?.width}x${data?.height}` : "";

    if (data?.material !== "WOOD") {
      return condition ? `${material}, ${LWH} - ${condition}` : `${material}, ${LWH}`;
    } else {
      return `${size}${grade}${moisture}${isHeatTreated}${palletType} - ${condition || ""}${hardOrSoftWood}`;
    }
  }

  const formatEquipmentTypes = equips => {
    const equipMapping = { "FLAT_BED": "Flatbed", "ENCLOSED_TRAILER": "Enclosed Trailer", "STRAIGHT_TRUCK": "Straight Truck" };
    return equips.map(equips => equipMapping[equips]).join(', ');
  }

  return (
    <RequestTenderModalWrapper>
      {(pageData && vendorsList?.length > 0) &&
        <Modal isOpen={true} centered={true} size={'lg'} className="request-tender-modal">
          <RequestTenderModalContentWrapper>
            <ModalBody>
              {loaderVisible && <Spinner />}
              <div className="outer-wrapper">
                <div className="header">
                  <h4>Create Tender</h4>
                  <img src={CloseIcon} alt="close-icon" onClick={() => props.closeModal()} />
                </div>
                <div className="details-wrapper">
                  <h4>Requested Delivery Details</h4>
                  <div className='first-row first-row-delivery-tender'>
                    <div>
                      <h6>Ref. No.</h6>
                      <p>{pageData?.orderRefNumber}</p>
                    </div>
                    <div>
                      <h6>Customer Name</h6>
                      <p>{pageData?.companyName}</p>
                    </div>
                    <div>
                      <h6>Delivery Location</h6>
                      <p style={{ marginBottom: '0px' }}>{pageData?.pickupLocation}</p>
                    </div>
                    <div>
                      <h6>Pallet Details</h6>
                      <p>{pageData?.reqPalletDetails ? palletDetailsString(pageData?.reqPalletDetails) : ''}</p>
                    </div>
                  </div>
                  <div className='first-row first-row-delivery-tender'>
                    <div>
                      <h6>Requested Date</h6>
                      <div className="date-picker-style">
                        <DatePickerIcon />
                        <p>{pageData?.requestedDate}</p>
                      </div>
                    </div>
                    <div className="app-timer-style">
                      <h6>Requested Window</h6>
                      <p style={{ margin: '0px', marginTop: '6px' }}><TimerIcon /> {pageData?.startTime} <span>To</span> <TimerIcon /> {pageData?.endTime}</p>
                    </div>
                    <div>
                      <h6>Equipment</h6>
                      <p>{pageData?.equipmentRequirements ? formatEquipmentTypes(pageData?.equipmentRequirements) : 'NA'}</p>
                    </div>
                    <div>
                      <h6>Estimated Qty.</h6>
                      <p>{pageData?.quantity}</p>
                    </div>
                  </div>
                  <p className="buyer-comment"><h6>Customer Load Comments:</h6>{pageData?.comments || 'NA'}</p>
                  <p className="buyer-comment"><h6>Internal Location/Rate Comments:</h6>{pageData?.flatFeeComments || 'NA'}</p>
                  <div className='second-row'>
                    <div>
                      <h6>Select Vendor</h6>
                      <SelectWrapper>
                        <DropDown
                          name="vendorList"
                          data={vendorsList}
                          searchDropDown={selectedVendor?.value}
                          searchable={true}
                          placeholder='Vendor Name'
                          onChangeHandler={(data) => setSelectedVendor(data)}
                        />
                      </SelectWrapper>
                    </div>
                  </div>
                  {selectedVendor &&
                    <div className='first-row first-row-delivery-tender'>
                      <div>
                        <h6>Customer Price</h6>
                        <p>{(selectedVendor?.customerFee && selectedVendor?.customerFee > 0) ? `$ ${selectedVendor?.customerFee}` : 'NA'}</p>
                      </div>
                      <div>
                        <h6>Vendor Price</h6>
                        <p>$ {selectedVendor?.vendorFee}</p>
                      </div>
                      <div>
                        <h6>Rate Type</h6>
                        <p>{selectedVendor ? (selectedVendor?.equipment || 'FTL') : ''}</p>
                      </div>
                      <div>
                        <h6>Comments</h6>
                        <p>{selectedVendor ? (selectedVendor?.vendorComment || 'NA') : ''}</p>
                      </div>
                    </div>
                  }
                  <div className="payment-section-styles">
                    <h4>Pay With:</h4>
                    <PaymentSection
                      paymentPageStateValues={paymentPageStateValues}
                      paymentDetails={pageData.paymentMethodDetails}
                      callBackPageDataApi={() => fetchPageData(pageData?.orderRefNumber)}
                      setPaymentPageStateValuesCallback={(id, value) => {
                        setPaymentPageStateValues((prevValues) => ({
                          ...prevValues,
                          [id]: value
                        }))
                      }}
                    />
                  </div>
                  <div className='third-row'>
                    <h6>External Load Comments to Supplier</h6>
                    <textarea
                      className="text-area"
                      value={comment}
                      onChange={(e) => (e.target.value.length <= 200 && setComment(e.target.value))}
                    />
                  </div>
                  {paymentPageStateValues?.isAchSelected &&
                    <div className="acknowledge-section-style">
                      <label>
                        <input
                          type="checkbox"
                          checked={paymentPageStateValues?.isAchBackupAcknowldged}
                          onChange={(e) => {
                            const updatedValues = { ...paymentPageStateValues, isAchBackupAcknowldged: e.target.checked };
                            setPaymentPageStateValues(JSON.parse(JSON.stringify(updatedValues)))
                          }}
                        />
                        I authorize that you can withdraw funds from my ACH account. If it fails, you can use my credit card.
                      </label>
                    </div>
                  }
                  <div className="button-wrapper">
                    <button onClick={requestTenderFunction}>Send Tender</button>
                  </div>
                </div>
              </div>
            </ModalBody>
          </RequestTenderModalContentWrapper>
        </Modal>
      }

      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType='success'
        callBackAlert={() => {
          if (alertModalType === 'closeModal') props.closeModal()
          else if (alertModalType === 'requestTendorSuccess') {
            props.closeModal()
            props.requestTendorSuccessCallBack()
          }
        }}
      />
    </RequestTenderModalWrapper>
  );
}

export default RequestTender;
